/**
 * Downloads a file either from a local File/Blob or a URL
 * @param file
 * @param fileName
 */
export const downloadFile = (file: DownloadFile, fileName?: string): void => {
  const createAndTriggerDownload = (file: Blob | File, name: string) => {
    const objectUrl = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  };

  const isBlob = typeof Blob !== "undefined" && file instanceof Blob;
  const isFile = typeof File !== "undefined" && file instanceof File;

  // Handle File or Blob
  if (isBlob || isFile) {
    // If no fileName is provided, use the file's original name (only for File type)
    const name = fileName || (file as File).name;

    createAndTriggerDownload(file, name);
  }

  // Handle URL string
  else if (typeof file === "string") {
    fetch(file)
      .then((response) => response.blob())
      .then((blob) => {
        // If no fileName is provided, extract it from the URL
        if (!fileName) {
          fileName = file.split("/").pop()?.split("?")[0] || "download";
        }
        createAndTriggerDownload(blob, fileName);
      })
      .catch((error) => console.error("Download failed", error));
  } else {
    console.error("Invalid file type passed to downloadFile");
    return;
  }
};
